import React from 'react';
import { Stack, Text, PrimaryButton } from 'office-ui-fabric-react';
import { connect } from 'react-redux';
import { Header } from './components/header';
import { FormattedMessage } from 'react-intl';
import { translate } from './localization/translate';
import axios from 'axios';
import { parameters } from './util/parameters';
const mapStateToProps = (state) => ({
    meeting: state.meeting.createdMeeting
});
const mapDispatchToProps = (dispatch) => ({
    onCopyToClipboard: (meeting) => {
        var _a;
        sendMeetingToLMS(meeting);
        alert(translate('copyMeetingPage.copy.alert'));
        const str = ((_a = document.getElementById('copy')) === null || _a === void 0 ? void 0 : _a.innerHTML) ||
            translate('copyMeetingPage.failed.copy');
        function listener(e) {
            var _a;
            if (!e || !e.clipboardData) {
                return;
            }
            e.clipboardData.setData('text/html', str);
            e.clipboardData.setData('text/plain', (_a = meeting === null || meeting === void 0 ? void 0 : meeting.joinWebUrl) !== null && _a !== void 0 ? _a : translate('copyMeetingPage.failed.copy'));
            e.preventDefault();
        }
        document.addEventListener('copy', listener);
        document.execCommand('copy');
        document.removeEventListener('copy', listener);
        // Redirect back to LMS
        const params = parameters.getInstance();
        if (params.getReturnUrl()) {
            window.location.href = params.getReturnUrl();
        }
    }
});
function sendMeetingToLMS(meeting) {
    var _a, _b;
    if (!meeting) {
        console.log('No meeting to send');
        return;
    }
    const params = parameters.getInstance();
    // Send request to the Node server to send the meeting to Learn
    const requestBody = {
        "startDateTime": (_a = meeting.startDateTime) === null || _a === void 0 ? void 0 : _a.toISOString(),
        "endDateTime": (_b = meeting.endDateTime) === null || _b === void 0 ? void 0 : _b.toISOString(),
        "subject": meeting.subject,
        "url": meeting.joinWebUrl,
        "nonce": params.getNonce(),
    };
    axios.post("/sendMeeting", requestBody, {
        headers: {
            'Content-type': 'application/json'
        }
    });
}
;
function CopyMeetingPageComponent(props) {
    var _a, _b;
    return (React.createElement(React.Fragment, null,
        React.createElement(Header, null),
        React.createElement(Stack, { className: "container", verticalFill: true, tokens: {
                childrenGap: 35
            } },
            React.createElement(Stack.Item, { align: "center", className: "meetingCardContainer" },
                React.createElement("svg", { className: "meetingSuccess", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 48 48" },
                    React.createElement("path", { d: "M24 0c2.2 0 4.3.3 6.4.9 2 .6 3.9 1.4 5.7 2.4 1.8 1 3.4 2.3 4.9 3.8 1.5 1.5 2.7 3.1 3.8 4.9 1 1.8 1.8 3.7 2.4 5.7.6 2 .9 4.2.9 6.4s-.3 4.3-.9 6.3c-.6 2-1.4 3.9-2.4 5.7-1 1.8-2.3 3.4-3.8 4.9-1.5 1.5-3.1 2.7-4.9 3.8-1.8 1-3.7 1.9-5.7 2.4-2 .6-4.1.9-6.4.9-2.2 0-4.3-.3-6.3-.9-2-.6-3.9-1.4-5.7-2.4-1.8-1-3.4-2.3-4.9-3.8-1.5-1.5-2.7-3.1-3.8-4.9-1-1.8-1.9-3.7-2.4-5.7C.3 28.3 0 26.2 0 24s.3-4.3.9-6.4c.6-2 1.4-3.9 2.4-5.7 1-1.8 2.3-3.4 3.8-4.9 1.5-1.5 3.1-2.7 4.9-3.8 1.8-1 3.7-1.9 5.7-2.4S21.8 0 24 0zm7.9 17.1c-.6 0-1.2.2-1.6.7l-8.5 8.5-3-3c-.4-.4-1-.7-1.6-.7-.3 0-.6.1-.8.2-.3.1-.5.3-.7.5s-.4.4-.5.7c-.2.3-.2.5-.2.8 0 .6.2 1.2.7 1.6l4.6 4.6c.4.4 1 .7 1.6.7.6 0 1.2-.2 1.6-.7l10.1-10.1c.4-.5.7-1 .7-1.6 0-.3-.1-.6-.2-.8-.1-.3-.3-.5-.5-.7s-.4-.4-.7-.5c-.4-.2-.7-.2-1-.2z", fill: "#599c00" })),
                React.createElement(Text, { block: true, variant: "xLarge", className: "meetingCardHeader" },
                    React.createElement(FormattedMessage, { id: "copyMeetingPage.header" })),
                React.createElement("div", { className: "meetingCardBody", id: "copy", dangerouslySetInnerHTML: { __html: (_b = (_a = props.meeting) === null || _a === void 0 ? void 0 : _a.preview) !== null && _b !== void 0 ? _b : '' } }),
                React.createElement(PrimaryButton, { className: "teamsButton copyButton", onClick: () => props.onCopyToClipboard(props.meeting), ariaLabel: translate('copyMeetingPage.copy.ariaLabel') },
                    React.createElement(FormattedMessage, { id: "copyMeetingPage.copy" }))))));
}
export default connect(mapStateToProps, mapDispatchToProps)(CopyMeetingPageComponent);
